<div class="selector-container">
  <aionz-header-bottom-sheet (onClose)="onClose()">
    {{ data().title }}
  </aionz-header-bottom-sheet>

  <div
    class="search-section"
    mat-dialog-content
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    [scrollWindow]="false"
    (scrolled)="onScrolled()"
  >
    <div class="search-wrapper">
      <aionz-input-search
        [formControl]="searchControl"
        [placeholder]="data().placeholder">
      </aionz-input-search>
    </div>

    <div class="list-container">
      <div class="list-content">
        @for (item of items(); track item.id) {
          <div class="user-item">
            <div class="user-info">
              <div class="avatar-container">
                @if (item.avatar) {
                  <img [src]="item.avatar" [alt]="item.name" class="avatar-img" />
                } @else {
                  <div class="avatar-placeholder" aria-hidden="true">
                    <span class="avatar-head"></span>
                    <span class="avatar-body"></span>
                  </div>
                }
              </div>
              <span class="user-name">{{ item.name }}</span>
            </div>
            <button
              mat-flat-button
              color="primary"
              type="button"
              class="action-button"
              (click)="onAction(item)">
              <mat-icon class="action-icon">{{ data().buttonIcon }}</mat-icon>
              <span class="action-label">{{ data().buttonLabel }}</span>
            </button>
          </div>
        }

        @if (isLoading()) {
          <div class="loading-state">
            <mat-spinner diameter="20"></mat-spinner>
            <p>Carregando...</p>
          </div>
        }

        @if (!isLoading() && items().length === 0) {
          <div class="empty-state">
            <p>Nenhum resultado encontrado.</p>
          </div>
        }
      </div>
    </div>
  </div>
</div>
